import { defineNuxtPlugin } from 'nuxt/app'

// Fuzzy search function with proper TypeScript typing
const fuzzySearch = (list: string, searchString: string): boolean => {
  const listItem = list.toLowerCase()
  let i = 0
  let n = -1
  let l: string
  const s = searchString?.toLowerCase()

  if (s) {
    for (i = 0; l = s[i++];) {
      if ((n = listItem.indexOf(l, n + 1)) === -1) return false
    }
    return true
  }
  else {
    return false
  }
}

// Vue type augmentation for adding $arFuzzySearch to the Vue instance
declare module 'vue' {
  interface ComponentCustomProperties {
    $arFuzzySearch: typeof fuzzySearch
  }
}

// Nuxt type augmentation for adding $arFuzzySearch to NuxtAppOptions
declare module '@nuxt/types' {
  interface NuxtAppOptions {
    $arFuzzySearch: typeof fuzzySearch
  }
}

// Vuex type augmentation for adding $arFuzzySearch to the store
declare module 'vuex' {
  interface Store<S> {
    $arFuzzySearch: typeof fuzzySearch
  }
}

// Define Nuxt plugin to provide $arFuzzySearch globally
export default defineNuxtPlugin((nuxtApp) => {
  console.log('SETUP AR_FUZZYSEARCH')
  nuxtApp.provide('arFuzzySearch', fuzzySearch)
})
